import { DirectiveBinding } from 'vue';

interface HTMLElementWithObserver extends HTMLElement {
  _io?: IntersectionObserver;
}

export const intersect = {
  mounted(el: HTMLElementWithObserver, binding: DirectiveBinding) {
    console.log('mounted')
    // The value passed should be a function.
    const callback = binding.value;
    if (typeof callback !== 'function') {
      console.warn('v-intersect value must be a function');
      return;
    }
    
    // Only use binding.arg if it's an object; otherwise default to threshold 0.1.
    const options: IntersectionObserverInit =
      (binding.arg && typeof binding.arg === 'object')
        ? binding.arg
        : { threshold: 0.1 };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
            console.log('callback')
            callback();
        }
      });
    }, options);

    observer.observe(el);
    el._io = observer;
  },
  unmounted(el: HTMLElementWithObserver) {
    console.log('unmounted')
    if (el._io) {
      el._io.disconnect();
      delete el._io;
    }
  }
};
